<ds-message [type]="messageType">
  {{infoMessage$ | async}}
  <a (click)="showInformation()"
     (keydown.enter)="showInformation()"
     class="focusable focusable__element ds-cursor--pointer"
     tabindex="0"
     [textContent]="linkText | cxTranslate"></a>
</ds-message>
<ds-modal
  [modalIsActive]="isModalOpen"
  [modalHeader]="modalHeading | cxTranslate"
  (canBeClosed)="closeEditModal()"
>
  <p [innerHtml]="modalContent | cxTranslate"></p>
</ds-modal>
